import angular from 'angular';
import angularMaterial from 'angular-material';
import changePasswordFactory from './changePassword.factory';

const changePasswordModule = angular
  .module('changePassword', [angularMaterial])
  .factory('ChangePassword', changePasswordFactory).name;

export default changePasswordModule;



// WEBPACK FOOTER //
// ./client/app/components/user/userDetails/changePassword/changePassword.js